
export enum ErrorDescriptionType {
  Text = "text",
  HTML = "html"
}
